// extracted by mini-css-extract-plugin
module.exports = {"fullWidth":"landing-module--fullWidth--179ql","document":"landing-module--document--pict3"};